import { put, takeLatest } from "redux-saga/effects";
import {
  GET_FUND_SPOTLIGHT,
  GET_FUND_SPOTLIGHT_INIT,
  GET_FUND_SPOTLIGHT_SUCCESS,
  GET_FUND_SPOTLIGHT_FAILED,
  GET_LIST_OF_STRATEGIES,
  GET_LIST_OF_STRATEGIES_INIT,
  GET_LIST_OF_STRATEGIES_SUCCESS,
  GET_LIST_OF_STRATEGIES_FAILED,
  GET_RECENT_CHAT,
  GET_RECENT_CHAT_INIT,
  GET_RECENT_CHAT_SUCCESS,
  GET_RECENT_CHAT_FAILED,
  GET_MEETINGS,
  GET_MEETINGS_INIT,
  GET_MEETINGS_SUCCESS,
  GET_MEETINGS_FAILED,
  GET_RECENT_POST_INIT,
  GET_RECENT_POST_SUCCESS,
  GET_RECENT_POST_FAILED,
  GET_RECENT_POST,
  GET_DASHBOARD_CONFIG_INIT,
  GET_DASHBOARD_CONFIG_SUCCESS,
  GET_DASHBOARD_CONFIG_FAILED,
  GET_DASHBOARD_CONFIG,
  UPDATE_DASHBOARD_CONFIG_INIT,
  UPDATE_DASHBOARD_CONFIG_SUCCESS,
  UPDATE_DASHBOARD_CONFIG_FAILED,
  UPDATE_DASHBOARD_CONFIG,
} from "./constants";
import { getUtil, postUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";

export function* getFundSpotlight({ payload }) {
  yield put({ type: GET_FUND_SPOTLIGHT_INIT });
  try {
    const res = yield getUtil(`${API.fundSpotlight}?isAnnual=${payload}`);

    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_FUND_SPOTLIGHT_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_FUND_SPOTLIGHT_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getDashboardConfig({ callback }) {
  yield put({ type: GET_DASHBOARD_CONFIG_INIT });
  try {
    const res = yield getUtil(`${API.getDashboardConfig}`);

    if (res?.status === 200) {
      callback();
      const { data } = res;
      yield put({ type: GET_DASHBOARD_CONFIG_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_DASHBOARD_CONFIG_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* updateDashboardConfig({ payload }) {
  yield put({ type: UPDATE_DASHBOARD_CONFIG_INIT });
  try {
    const res = yield postUtil(`${API.updateDashboardConfig}`, payload);

    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: UPDATE_DASHBOARD_CONFIG_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: UPDATE_DASHBOARD_CONFIG_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getListOfStrategies() {
  yield put({ type: GET_LIST_OF_STRATEGIES_INIT });
  try {
    const res = yield getUtil(API.GetListOfStrategies);

    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_LIST_OF_STRATEGIES_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_LIST_OF_STRATEGIES_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getRecentChats() {
  yield put({ type: GET_RECENT_CHAT_INIT });
  try {
    const res = yield getUtil(`${API.GetRecentChat}`);

    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_RECENT_CHAT_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_RECENT_CHAT_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getMeetingsDashBoard() {
  yield put({ type: GET_MEETINGS_INIT });
  try {
    const res = yield getUtil(`${API.GetDashboardMeetings}`);

    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_MEETINGS_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_MEETINGS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getRecentPosts() {
  yield put({ type: GET_RECENT_POST_INIT });
  try {
    const res = yield getUtil(`${API.GetRecentPost}`);

    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_RECENT_POST_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_RECENT_POST_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* dashboard() {
  yield takeLatest(GET_FUND_SPOTLIGHT, getFundSpotlight);
  yield takeLatest(GET_LIST_OF_STRATEGIES, getListOfStrategies);
  yield takeLatest(GET_RECENT_CHAT, getRecentChats);
  yield takeLatest(GET_MEETINGS, getMeetingsDashBoard);
  yield takeLatest(GET_RECENT_POST, getRecentPosts);
  yield takeLatest(GET_DASHBOARD_CONFIG, getDashboardConfig);
  yield takeLatest(UPDATE_DASHBOARD_CONFIG, updateDashboardConfig);
}
